import { Box, Button, Typography } from '@mui/material';
import { ActivityTimeline } from './ActivityTimeline';
import type { BaseEventTimelineItem } from '../../../types/eventTimeline';

interface PagedActivityTimelineProps {
  events: BaseEventTimelineItem[];
  totalCount: number;
  hasMore: boolean;
  isLoading: boolean;
  isLoadingMore: boolean;
  loadMore: () => void;
}

export function PagedActivityTimeline({
  events,
  totalCount,
  hasMore,
  isLoading,
  isLoadingMore,
  loadMore,
}: PagedActivityTimelineProps) {
  return (
    <Box>
      <ActivityTimeline events={events} isLoading={isLoading} />
      {hasMore && (
        <Button
          variant="outlined"
          onClick={loadMore}
          disabled={isLoadingMore}
          fullWidth
          sx={{ mt: 2 }}
        >
          {isLoadingMore ? 'Loading...' : 'Load More'}
        </Button>
      )}
      {hasMore && !isLoading && (
        <Typography
          variant="caption"
          color="text.disabled"
          align="center"
          sx={{ display: 'block', mt: 1 }}
        >
          Showing {events.length} of {totalCount}
        </Typography>
      )}
    </Box>
  );
}
